import { createSelector } from '@reduxjs/toolkit';

import { IAddressPreview, IBlockedUser, IShippingAddress, IStore2 } from 'types';
import { Countries } from 'constant/countries';

const DEFAULT_ADDRESS_SUGGESTION: IAddressPreview = {
  country: Countries.UnitedStates,
  state: null,
  city: '',
  address: '',
  postalCode: '',
};

const blockedUsersSelector = (state: IStore2) => state.settings.blockedUsers;

const shippingAddressesSelector = (state: IStore2) => state.settings.shippingAddresses;

const newAddressSuggestionSelector = (state: IStore2) =>
  state.popup.addressSuggestion || DEFAULT_ADDRESS_SUGGESTION;

const blockUserSelector = createSelector(
  [blockedUsersSelector],
  (blockedUsers): IBlockedUser[] | null => {
    if (blockedUsers) {
      return blockedUsers.map((item) => ({
        isBlocked: true,
        userName: item.userName,
        id: item.id,
        avatar: item.avatar,
        name: item.name,
      }));
    }

    return null;
  },
);

const defaultShippingAddressSelector = createSelector(
  [shippingAddressesSelector],
  (shippingAddresses): IShippingAddress | null => {
    return shippingAddresses?.find((item) => item.isDefault) || null;
  },
);

export const SettingsSelector = {
  blockUserSelector,
  newAddressSuggestionSelector,
  defaultShippingAddressSelector,
};
